import React, {useState, useEffect} from 'react';
import Article from '../Components/Article'

const Default = () => <Article page={'Hello There!'} />;

export default Default;
